import { Avatar, Grid, ListItem } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIXES = {
  cancelIcon: "cancel-icon",
  masterListItem: "master-list-item",
};

export const masterListItemclasses = {
  archived: `${PREFIXES.masterListItem}-archived`,
  selected: `${PREFIXES.masterListItem}-selected`,
  chip: `${PREFIXES.masterListItem}-chip`,
};

export const cancelIconClasses = {
  selected: `${PREFIXES.cancelIcon}-selected`,
};

export const ItemAvatar = styled(Avatar)(({ theme }) => ({
  color: theme.palette.surface.main,
  alignItems: "center",
}));

export const ChipContainer = styled(Grid)({
  fontSize: "16px",
  position: "absolute",
  right: "15px",
  top: "50%",
  transform: "translateY(-50%)",
});

export const MasterListItem = styled(ListItem)(({ selected, theme }) => ({
  backgroundColor: "transparent",
  padding: "15px",
  cursor: "pointer",
  "& .removing": {
    WebkitAnimation: "fadeOut 500ms",
    MozAnimation: "fadeOut 500ms",
    animation: "fadeOut 500ms",
  },
  "&:hover": {
    backgroundColor: theme.palette.surface.main,
    [`& .${masterListItemclasses.chip}`]: {
      backgroundColor: selected ? theme.palette.surface.dark : theme.palette.surface.main,
    },
    [`&.${masterListItemclasses.archived}`]: {
      color: theme.palette.black.main,
    },
  },
  [`& .${masterListItemclasses.chip}`]: {
    backgroundColor: theme.palette.surface.main,
  },
  [`&.${masterListItemclasses.selected}`]: {
    backgroundColor: theme.palette.surface.main,
    [`& .${masterListItemclasses.chip}`]: {
      backgroundColor: theme.palette.surface.dark,
    },
  },
}));

export const CancelIconWrapper = styled(Grid)(({ theme }) => ({
  borderRadius: "50%",
  height: "22px",
  width: "22px",
  position: "relative",
  "& svg": {
    borderRadius: "50%",
    textAlign: "left",
    position: "absolute",
    left: "-3px",
    top: "-3px",
  },
  [`&.${cancelIconClasses.selected}`]: {
    "&:hover": {
      backgroundColor: theme.palette.surface.main,
    },
    "& svg": {
      "&:hover": {
        color: theme.palette.primary.dark,
      },
    },
  },
}));
